import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
    TextField,
    FormControl,
    Switch,
    useTheme,
    SelectChangeEvent,
    FormHelperText,
    InputLabel,
    Select,
    MenuItem,
    Autocomplete,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Group } from "../../../Shared-ui/Types/Group";
import { ADD_MODELS_ADMIN, ADMIN_GROUPS, ADMIN_USERS, GET_ALL_MODELS_ADMIN, MODELS, PROVIDERS, TEAMS, UPDATE_MODEL_ADMIN,
        GET_ALL_MODELS
 } from "../../../Services/Endpoint";
import { StartLoading, StopLoading } from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import { useDispatch } from "react-redux";
import { ShowError, ShowSuccess } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import BaseInstance from "../../../Services/AxiosInstance/BaseInstance";
import { isOnlyAlphabetsNumbers } from "../../../Shared-ui/utils/Common/Common";
import { User } from "../../../Shared-ui/Types/User";
import { Model } from "../../../Shared-ui/Types/Models";
import { set } from "date-fns";
import { NotSelected } from "../../../Constant/Setting";

interface MyComponentProps {
    open: boolean;
    handleClose: () => void;
    model: Model | null
}

const options = ['Admin', 'Editor', 'Viewer'];
const CreateModel: React.FC<MyComponentProps> = (props) => {
    const theme = useTheme();
    const ModelInitial: Model = {
        provider: NotSelected,
        model: "",
        description: "",
    };
    const modelErrInitial = {
        provider: { error: "", value: false },
        model: { error: "", value: false },
        description: { error: "", value: false },
    };

    const [modelErr, setModelErr] = useState(modelErrInitial);
    const dispatch = useDispatch();
    const [model, setModel] = React.useState<Model>(ModelInitial);
    const [isEditing, setIsEditing] = useState(false)
    const [providers, setProviders] = useState<string[]>([]);
    const [modelObj, setModelObj] = useState<Record<string, string[]> | null>(null);
    const [modelList, setModelList] = useState<string[]>([]);



    useEffect(() => {
        getAllModels();
    }, [])

    useEffect(() => {
        if (props.model) {
            setIsEditing(true);
            setModel(props.model);
            if (modelObj && props.model.provider) {
                setModelList(modelObj[props.model.provider] || []);
            }
        } else {
            setModelList([]);
        }
    }, [props.open, props.model, modelObj])



    const getAllModels = async () => {
        try {
            dispatch(StartLoading());
            const data = await BaseInstance.get(GET_ALL_MODELS).then((res) => res?.data);
            setProviders(Object.keys(data));
            setModelObj(data)
            dispatch(StopLoading());
        }catch (err: any) {
            dispatch(ShowError(err?.response?.data?.detail));
            dispatch(StopLoading());
        }
    };




    const validateModels = () => {
        let error = 0
        const setError = (field: string, condition: boolean, message: string) => {
            if (condition) {
                setModelErr(prev => ({
                    ...prev,
                    [field]: { error: message, value: true }
                }));
                error += 1;
            } else {
                setModelErr(prev => ({
                    ...prev,
                    [field]: { error: "", value: false }
                }));
            }
        };


        // description 
        setError("provider", model.provider === NotSelected || !model.provider.trim(), "Please select a provider");
        setError("model", !model.model.trim(), "Please enter the model");

        return error === 0 ? true : false
    }

    const createModel = async () => {
        if (!validateModels()) return
        try {
            dispatch(StartLoading());
            const data = await BaseInstance.post(ADD_MODELS_ADMIN, model).then((res) => res?.data);
            dispatch(ShowSuccess("Model created successfully"))
            handleClose();
        } catch (err: any) {
            dispatch(ShowError(err?.response?.data?.detail));
        } finally {
            dispatch(StopLoading());
        }

    }

    const updateModel = async () => {
        if (!validateModels()) return
        try {
            dispatch(StartLoading());
            const data = await BaseInstance.put(`${UPDATE_MODEL_ADMIN}/${model.id}`, model).then((res) => res?.data);
            dispatch(ShowSuccess("Model updated successfully"))
            handleClose();
        } catch (err: any) {
            dispatch(ShowError(err?.response?.data?.detail));
        } finally {
            dispatch(StopLoading());
        }

    }

    const handleChange = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | SelectChangeEvent | any
    ) => {
        const { name, value } = event.target;
        
        setModel((prev) => ({
                ...prev,
                [name]: value,
            }));

        if (name === "provider"){
            setModelList(modelObj && modelObj[value] ? modelObj[value] : []);
            setModel((prev) => ({
                ...prev,
                model: "",
            }));
        }
    };

    interface ModelSelectionEvent {
        value: string;
    }

    interface HandleModelSelectionEvent {
        value: string;
    }

    const handleModelSelection = (
        e: React.SyntheticEvent<Element, Event>,
        value: string
    ): void => {
        setModel((prev) => ({
            ...prev,
            model: value,
        }));
    }


    const handleClose = () => {
        setIsEditing(false);
        setModelErr(modelErrInitial);
        setModel(ModelInitial);
        setModelList([]);
        props.handleClose();
    }


    return (
        <Dialog open={props.open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle
                sx={{
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 2,
                }}
            >
                <Box>
                    {!isEditing ? "Create" : "Update"} Model
                    <Typography
                        variant="subtitle2"
                        color="textSecondary"
                        sx={{ mt: 0.5 }}
                    >
                        {!isEditing ? "Create a new model" : "Edit the model details"}
                    </Typography>
                </Box>
                <IconButton onClick={handleClose} sx={{ ml: 1 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ p: 3 }}>
                <Box
                    component="form"
                    // onSubmit={handleSubmit}
                    sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}
                >
                    <FormControl
                        fullWidth
                        variant="outlined"
                        sx={{ mt: theme.spacing(2) }}
                        error={modelErr.provider.value}
                    >
                        {/*Consistent spacing*/}
                        <InputLabel>Provider *</InputLabel>
                        <Select
                            name="provider"
                            onChange={handleChange}
                            label="Provider & Model"
                            value={model.provider || NotSelected}
                        >
                            <MenuItem value={NotSelected}>Please select provider</MenuItem>
                            {providers.map((provider, index) => (
                                <MenuItem value={provider} key={index}>
                                    {provider}
                                </MenuItem>
                            ))}
                        </Select>
                        {modelErr.provider.value && (
                            <FormHelperText>{modelErr.provider.error}</FormHelperText>
                        )}
                    </FormControl>
                    <FormControl 
                        fullWidth 
                        variant="outlined" 
                        sx={{ mt: theme.spacing(2) }}
                        error={modelErr.model.value}>
                         <InputLabel id="model-label">Model *</InputLabel>
                            <Select
                                labelId="model-label"
                                label="Model *"
                                name="model"
                                value={model.model}
                                onChange={handleChange}
                            >
                                {modelList.map((item, index) => (
                                    <MenuItem key={index} value={item}>
                                        {item}
                                    </MenuItem>
                                ))}
                            </Select>
                    </FormControl>

                    <FormControl fullWidth variant="outlined" sx={{ mb: 1 }} error={modelErr.description.value}>
                        <TextField
                            fullWidth
                            label="Description"
                            name="description"
                            value={model.description}
                            onChange={handleChange}
                            placeholder="Team description"
                            multiline
                            rows={4}
                            inputProps={{ maxLength: 500 }}
                            error={modelErr.description.value}
                            helperText={modelErr.description.error}
                        />
                        <Box display="flex" justifyContent="flex-end">
                            <Typography variant="caption" color="textSecondary" align="right">
                                {`${(model.description ?? "").length} / ${500} characters`}
                            </Typography>
                        </Box>
                    </FormControl>
                </Box>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={handleClose} color="primary" variant="outlined" size="large" sx={{ textTransform: "capitalize", }}>
                    Cancel
                </Button>
                <Button variant="contained" color="primary" size="large" sx={{ textTransform: "capitalize", }}
                    onClick={() => isEditing ? updateModel() : createModel()}
                    disabled={!model.provider || !model.model}
                // disableElevation
                >
                    {isEditing ? "Update" : "Create"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CreateModel;